export const PANEL_NAVIGATION_AUTO_COLLAPSE_EVENT =
  'panel-navigation-auto-collapse'

export const requestPanelNavigationAutoCollapse = collapsed => {
  if (typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent(PANEL_NAVIGATION_AUTO_COLLAPSE_EVENT, {
      detail: Boolean(collapsed)
    })
  )
}
